import { createSlice } from '@reduxjs/toolkit'

const appLoaderSlice = createSlice({
  name: 'appLoader',
  initialState: {
    showAppLoader: true,
  },
  reducers: {
    showAppLoader: (state) => {
      state.showAppLoader = true;
    },
    hideAppLoader: (state) => {
      state.showAppLoader = false;
    }
  },
})

export const {
  showAppLoader,
  hideAppLoader,
} = appLoaderSlice.actions;

export default appLoaderSlice.reducer;